import { type BackendMessageStageInput } from '@post-office/message-maker-node/placements/types';

import { buildPlaceOrderHref } from '../../../build-place-order-href';
import { type MessageContextFields } from '../../..';
import { hasViewedModal } from '../../../has-viewed-modal';

export type ConfluenceSideNavHydrateResult = {
	entitlementId: string;
	placeOrderHref: string;
	edition: string;
	productName: string;
	shouldForceOpenModal: boolean;
};

export const hydrate = async ({
	message,
	request,
}: BackendMessageStageInput<MessageContextFields>): Promise<ConfluenceSideNavHydrateResult> => {
	const { entitlementId, transactionAccountId, tenantId, edition, productName } = message.context;
	const envType = request.executionRuntime.getEnvironmentType();

	const placeOrderHref = buildPlaceOrderHref({
		envType,
		transactionAccountId,
		entitlementId,
		edition,
	});

	const hasViewed = await hasViewedModal({
		userId: request.orchestrationContext.recipient?.userId,
		tenantId,
		traitName: 'confluence_screen_viewed_confluencerecentdowngradediscountmodal_first_time',
		metrics: request.metrics,
		logger: request.logger,
		cachedTapClient: request.restApiClients?.cachedTapClient,
	});

	return {
		entitlementId,
		placeOrderHref,
		edition,
		productName,
		shouldForceOpenModal: !hasViewed,
	};
};
